import type { RefObject } from 'react';
import type { StateCreator } from 'zustand';
import {
  DEFAULT_CURRENCIES,
  getCurrenciesByCountry,
  getCurrenciesByLicense,
} from '@/helpers/currency';
import { getCurrencyCentsAndCode } from '@/helpers/wallet';
import { type CommonStoreType, License, type TechInfoState } from '../types';

export const useTechInfoSlice: StateCreator<
  CommonStoreType,
  [],
  [],
  TechInfoState
> = (set, getState) => ({
  pendingStore: true,
  isMobileDevice: false,
  serverError: null,
  gameOpenBackUrl: null,
  hostname: '',
  userIP: '',
  countryCode: '',
  regionCode: '',
  cmsABTests: [],
  cmsConfig: null,
  exchangeRates: null,
  riskSegment: 'S10',

  enableCurrencies: DEFAULT_CURRENCIES,
  formatAmountByCurrency: (amount: number, currency: string) =>
    getCurrencyCentsAndCode(amount, currency, DEFAULT_CURRENCIES).amount,
  tabBarHeight: 0,
  handleTabBarHeight: (ref: RefObject<HTMLDivElement>) => {
    if (ref === null) return;
    ref.current?.clientHeight
      ? set({ tabBarHeight: ref.current?.clientHeight })
      : set({ tabBarHeight: 0 });
  },

  setCountryCodeData: (isEstonia: boolean) => {
    try {
      const { countryCode, user } = getState();

      if (!(user?.country || countryCode)) return;

      const resolvedCountryCode = user?.country || countryCode;

      const currenciesByCountry = getCurrenciesByCountry(
        DEFAULT_CURRENCIES,
        resolvedCountryCode
      );
      const currenciesByLicense = getCurrenciesByLicense(
        currenciesByCountry,
        isEstonia ? License.EE : License.CW
      );
      set({ enableCurrencies: currenciesByLicense });
    } catch (error) {
      console.log(error);
    }
  },
  authProvidersOptions: [],
});
